import React, { useEffect, useState } from "react";
import "./Rowpost.css";
import axios from "../../axios";
import { ImgUrl, API_KEY } from "../../constants/Constants";
import YouTube from "react-youtube";

function Rowpost(props) {
  const [movies, setMovies] = useState([]);
  const [urlId, seturlId] = useState("");
  useEffect(() => {
    axios.get(props.url).then((response) => {
      console.log(response.data);
      setMovies(response.data.results);
    });
  }, [props.url]);

  const opts = {
    height: "390",
    width: "100%",
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: 1,
    },
  };

  const handlemovie = (id) => {
    console.log(id);
    axios
      .get(`movie/${id}/videos?api_key=${API_KEY}&language=en-US`)
      .then((response) => {
        if (response.data.results.length !== 0) {
          seturlId(response.data.results[0]);
        }
      });
  };
  return (
    <div className="row">
      <h2>{props.title}</h2>
      <div className="posters">
        {movies.map((obj, index) => {
          return (
            <img
              onClick={() => {
                handlemovie(obj.id);
              }}
              key={index}
              className={props.isSmall ? "smallposter" : "poster"}
              alt="poster"
              src={`${ImgUrl + obj.backdrop_path}`}
            />
          );
        })}
      </div>
      {urlId && <YouTube opts={opts} videoId={urlId.key} />}
    </div>
  );
}

export default Rowpost;
